// extracted by mini-css-extract-plugin
export default {"ResetPassword":"ResetPassword_ResetPassword__QL9OY","ResetPasswordBox":"ResetPassword_ResetPasswordBox__v2kq9"};